import { gql } from "@apollo/client";

export const DYNAMIC_TRANSLATION_FIELDS_FRAGMENT = gql`
	fragment DynamicTranslationFields on DynamicTranslation {
		id
		language
		text
		translation
		entityId
		entityStatus
		type
		group
		groupEntityId
		createdBy
		editedBy
		createdAt
		updatedAt
	}
`;
